export default __webpack_public_path__ + "static/media/robot.e21d67d1.svg";